import React from 'react';

import PropTypes from 'prop-types';

import StatusView from '@vfgroup-oneplatform/foundation/Components/StatusView';

import Description from '../Description/Description';

import styles from './Success.style';

const Success = ({
  closeQAMAndInvokeOnPress,
  title,
  primaryButtonProps,
  secondaryButtonProps,
  ...rest
}) => {
  return (
    <StatusView
      lottieProps={{
        type: 'tick',
        autoPlay: true,
        loop: false,
        lottieViewStyle: styles.lottieViewStyle,
      }}
      title={title}
      renderDescription={() => <Description {...rest} />}
      containerStyle={styles.successViewContainer}
      textStyles={{
        textContainer: styles.successTextContainer,
        title: styles.titleStyle,
      }}
      {...(primaryButtonProps && {
        primaryButtonProps: {
          ...primaryButtonProps,
          onPress: closeQAMAndInvokeOnPress(primaryButtonProps),
          ...(!secondaryButtonProps && {
            style: styles.primaryButton,
          }),
        },
      })}
      {...(secondaryButtonProps && {
        secondaryButtonProps: {
          ...secondaryButtonProps,
          onPress: closeQAMAndInvokeOnPress(secondaryButtonProps),
        },
      })}
    />
  );
};

Success.propTypes = {
  closeQAMAndInvokeOnPress: PropTypes.func,
  title: PropTypes.string.isRequired,
  primaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
  secondaryButtonProps: PropTypes.shape({
    title: PropTypes.string,
    onPress: PropTypes.func,
    type: PropTypes.string,
  }),
};

export default Success;
